import en from './en';
import type { TranslationSchema } from './en';

const ta: TranslationSchema = {
    ...en,
};

export default ta;
